export default {
    methods: {
        getLocalisedText() {
            switch (this.$store.state.language) {
                case "sv":
                default:
                    return {
                        operationSpanLabel: 'Talet',
                        readingSpanLabel: 'Frågan',
                        spatialSpanLabel: "Rutan",
                        digitsUpdatingLabel: "Siffran",
                    };
            }
        }
    }
}
